import styled from 'styled-components'

export const StyledFilterRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledFilterPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`
